import { render } from "./BSAlert.vue?vue&type=template&id=6413890d"
import script from "./BSAlert.vue?vue&type=script&lang=js"
export * from "./BSAlert.vue?vue&type=script&lang=js"

import "./BSAlert.vue?vue&type=style&index=0&id=6413890d&lang=css"
script.render = render

export default script